<template>
  <StIconButton icon="circle-question" label="Formatting help" @click="open = true" />
  <StModal :open="open" title="Text formatting" @close="open = false">
    <p class="fmt-help__intro">
      These shortcuts work in any text field (rules, twist, scoring, ability effects).
    </p>
    <table class="fmt-help">
      <tbody>
        <tr v-for="row in rows" :key="row.code">
          <td>
            <code>{{ row.code }}</code>
          </td>
          <td class="fmt-help__desc" v-html="row.desc" />
        </tr>
      </tbody>
    </table>
    <template #footer>
      <StButton variant="primary" @click="open = false">Got it</StButton>
    </template>
  </StModal>
</template>

<script setup lang="ts">
import { ref } from 'vue';
import { StIconButton, StModal, StButton } from './ui/index.js';

const open = ref(false);

const rows: { code: string; desc: string }[] = [
  { code: '**bold**', desc: '<b>bold</b>' },
  { code: '*italic*', desc: '<i>italic</i>' },
  {
    code: '**^^keyword^^**',
    desc: '<b style="font-variant: small-caps">bold small caps</b> (keyword style)',
  },
  { code: '* item  /  - item', desc: 'a bullet (at the start of a line)' },
  { code: '•', desc: 'a bullet' },
  {
    code: '**Sun Seekers**',
    desc: 'bolded objective names get a colored dot (Sun Seekers, Golden Lions, Heldenhain, Sigmarite, …)',
  },
  { code: '(new line)', desc: 'line breaks are preserved' },
];
</script>

<style scoped>
.fmt-help__intro {
  margin: 0 0 var(--st-space-3);
  color: var(--st-text-muted);
  font-size: var(--st-text-sm);
}
.fmt-help {
  border-collapse: collapse;
  width: 100%;
}
.fmt-help td {
  padding: var(--st-space-1) var(--st-space-2);
  vertical-align: top;
  border-bottom: 1px solid var(--st-border);
}
.fmt-help code {
  font-family: var(--st-font-mono, monospace);
  font-size: var(--st-text-sm);
  background: var(--st-surface-sunken);
  padding: 1px var(--st-space-1);
  border-radius: var(--st-radius-xs);
  white-space: nowrap;
}
.fmt-help__desc {
  color: var(--st-text);
  font-size: var(--st-text-sm);
}
</style>
